import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],

})
export class HeaderComponent implements OnInit {

  constructor(public router: Router) { }
  triconPhone = environment.triconPhone;
  triconDomain = environment.triconDomain;

  ngOnInit(): void {
  }

  callTricon() {
    if (isMobileDevice() == true) {
      window.location.href = 'tel:' + this.triconPhone;
    }

    function isMobileDevice() {
      return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    };
  }
}
